export const INITIAL_NAVIGATION_EXISTING_INSURANCE = '/existing-insurance';
export const INITIAL_NAVIGATION_UNIQUE_SELLING_POINTS = '/unique-selling-points';
